import { useMutation, useQuery } from "@apollo/client";
import { graphql } from "~/gql";

export const DYNAMIC_TAGS_QUERY = graphql(/* GraphQL */ `
  query DynamicTags {
    dynamicTags {
      id
      name
      token
      dynamicTagEntries {
        id
        contents
        contentType
        dynamicTagId
        condition {
          id
          officeId
          organisationalUnitId
          condition
        }
      }
    }
  }
`);

export const CREATE_DYNAMIC_TAG = graphql(/* GraphQL */ `
  mutation CreateDynamicTag($createInput: DynamicTagCreateInput!) {
    createDynamicTag(createInput: $createInput) {
      id
    }
  }
`);

export const UPDATE_DYNAMIC_TAG = graphql(/* GraphQL */ `
  mutation UpdateDynamicTag($update: DynamicTagUpdateInput!, $updateDynamicTagId: Int!) {
    updateDynamicTag(update: $update, id: $updateDynamicTagId) {
      id
    }
  }
`);

export const createDynamicTag = () => {
  return useMutation(CREATE_DYNAMIC_TAG);
};

export const updateDynamicTag = () => {
  return useMutation(UPDATE_DYNAMIC_TAG);
};

export const deleteDynamicTag = () => {
  return useMutation(
    graphql(/* GraphQL */ `
      mutation DeleteDynamicTag($deleteDynamicTagId: Int!) {
        deleteDynamicTag(id: $deleteDynamicTagId) {
          id
        }
      }
    `)
  );
};

export const getDynamicTags = () => {
  return useQuery(DYNAMIC_TAGS_QUERY);
};
